import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

class Caret extends React.PureComponent<any, any> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <polygon points="17.7,10.3 16.3,8.9 12,13.2 7.8,8.9 6.3,10.3 12,16 12,16 12,16 " />
            </SvgIcon>
        );
    }
}

export default Caret;
